import React, { Component } from "react";
import IntroSection from "components/intro-section/IntroSection";
import Filter from "components/filter/Filter";
import axios from "axios";
import { renderAttribute } from "functions/renderAttribute";
import NavigationCircle from "components/navigation/circle/NavigationCircle";
import { Link } from "react-router-dom";
import moment from "moment";
import Placeholders from "components/placeholders/Placeholders";

export default class DocumentiPNRR extends Component {
  state = {
    loading: false,
    active: { folder: "CIRCOLARI" },
    list: [],
    folders: [],
    classesFilter: [],
    valuesFilter: [],
    from: 1,
  };
  handleChange = async (value, target) => {
    this.setState({ active: { ...this.state.active, [target]: value } });
  };

  handleReset = () => {
    this.setState({ active: {} });
  };

  fetchFilter = async (path) => {
    let folders = await axios.post(
      "https://api.utilitalia.it/DMS/Folders/List",
      {
        path: "\\AREA DIREZIONE GENERALE\\Pianificazione\\PNRR\\DOCUMENTI",
      }
    );
    folders = folders?.data?.data?.folders || [];
    folders = folders.map((element) => {
      return element.code;
    });
    folders.sort((a, b) => (a > b ? -1 : b > a ? 1 : 0));

    this.setState({ folders });
  };

  fetchDocument = async (folder, filter, tipo) => {
    try {
      let response = await axios.post(
        "https://api.utilitalia.it/DMS/Documents/List",
        {
          documentClasses: ["DOCUMENTI"],
          heading: "\\AREA DIREZIONE GENERALE\\Pianificazione\\PNRR\\DOCUMENTI",
          folder: folder || "",
          pageStart: this.state.from,
          pageSize: 10,
          documentValueOrders: [
            {
              code: "DATA",
              type: "5",
              direction: "desc",
            },
          ],
          documentValueFilters: [
            {
              code: tipo ? "TIPO" : "TIPOLOGIA",
              type: "1",
              start: filter,
            },
          ],
        }
      );
      response = response?.data?.data;
      if (response) {
        this.setState({
          pages: response?.totalPages,
          list: response?.documents,
        });
      }
    } catch (err) {
      console.log("error");
    }
  };

  fetchCircolari = async () => {
    console.log("FETCH CIRCOLARI");

    let payload = {
      aree:
        this.state.active.area && this.state.active.area !== "SELEZIONA"
          ? [this.state.active.area]
          : null,
      //       startDate: this.state.active.year
      //         ? this.state.active.year + "-01-01"
      //         : moment().format("YYYY") + "-01-01",
      //       endDate: this.state.active.year
      //         ? moment(this.state.active.year).add(1, "y").format("YYYY-MM-DD")
      //         : moment().add(1, "y").format("YYYY-MM-DD"),
      pageSize: "20",
      pageStart: 1,
      orderDirection: "desc",
    };
    payload.argomentiPerNome = ["PNRR"];
    try {
      let response = await axios.post(
        "https://api.utilitalia.it/UTI/CIR/Circolari/List",
        {
          ...payload,
        }
      );
      response = response?.data?.data;
      if (response) {
        this.setState({
          pages: response?.totalPages,
          list: response?.circolari,
        });
      }
    } catch (err) {
      console.log("error");
    }
  };

  componentDidMount() {
    this.fetchFilter();
    this.fetchCircolari();
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevState.active !== this.state.active) {
      console.log("update");
      if (this.state.active.folder === "CIRCOLARI") {
        this.fetchCircolari();
      } else {
        this.fetchDocument(this.state.active.folder);
      }
    }
  }

  render() {
    console.log("FILTERS", this.state.folders);
    const filters = [
      {
        name: "tipologia",
        values: this.state.classesFilter,
      },
      {
        name: "folder",
        values: this.state.folders,
      },
      {
        name: "value",
        values: this.state.valuesFilter,
      },
    ];
    return (
      <div id="single-document">
        <IntroSection
          category={"Direzione Generale"}
          subsector={"Pianificazione Strategia Sostenibilita"}
          subsubsector={"PNRR Documenti"}
        />
        <div className="container pad-mobile">
          <h2
            className="general"
            //             dangerouslySetInnerHTML={{
            //               __html:
            //                 renderFunction(this.props.match.url) &&
            //                 renderFunction(this.props.match.url).title,
            //             }}
          >
            PNRR Documenti
          </h2>
          <Filter
            filters={filters}
            value={this.state.active}
            change={this.handleChange}
            //             reset={this.handleReset}
          />
          <div className="general-list">
            {this.state.loading ? (
              <Placeholders number={3} type="new" />
            ) : !this.state.list || this.state.list?.length === 0 ? (
              <p>Nessun risultato</p>
            ) : (
              this.state.list.map((element, i) => {
                console.log("elemente", element);
                return (
                  <div className="item" key={i}>
                    <div className="left">
                      {this.state.active.folder === "CIRCOLARI" ? (
                        <span className="date">
                          {moment(element.data).format("ll")}
                        </span>
                      ) : (
                        <span className="date">
                          {/* {renderAttribute(element.values, "DATA")} */}
                          {renderAttribute(element.values, "CITTA")
                            ? renderAttribute(element.values, "AZIENDA") +
                              " - " +
                              renderAttribute(element.values, "CITTA")
                            : renderAttribute(element.values, "NUMEROATTO")
                            ? renderAttribute(element.values, "NUMEROATTO")
                            : moment(
                                renderAttribute(element.values, "DATA")
                              ).format("ll")}
                        </span>
                      )}
                      {this.state.active.folder === "CIRCOLARI" ? (
                        element.oggetto
                      ) : (
                        <h4>
                          {renderAttribute(element.values, "NUMERO_FOCUS") &&
                            renderAttribute(element.values, "NUMERO_FOCUS") +
                              " "}
                          {renderAttribute(element.values, "ANNO")
                            ? renderAttribute(element.values, "TITOLO").concat(
                                " - " + renderAttribute(element.values, "ANNO")
                              )
                            : renderAttribute(element.values, "TITOLO")}
                          {renderAttribute(element.values, "NOMEATTO")}
                        </h4>
                      )}
                    </div>
                    <Link
                      to={
                        this.state.active.folder === "CIRCOLARI"
                          ? `/circolare/${element.id}`
                          : "/" +
                            this.props.match.url.split("/")[1] +
                            "/" +
                            this.props.match.url.split("/")[2] +
                            "/list/" +
                            element.id
                      }
                      className="btn"
                      style={{ marginLeft: "20px" }}
                    >
                      Leggi di più
                    </Link>
                  </div>
                );
              })
            )}
          </div>
          {this.state.pages > 1 && (
            <NavigationCircle
              function={this.handleNavigation}
              color="var(--greyDarkColor)"
              disabled={this.state.from === 1}
            />
          )}
        </div>
      </div>
    );
  }
}
